
const _state = {
  menuItemId: null,
  companies: sessionStorage.getItem('user-companies')
    ? JSON.parse(sessionStorage.getItem('user-companies'))
    : null,
  permissions: sessionStorage.getItem('user-permissions')
    ? JSON.parse(sessionStorage.getItem('user-permissions'))
    : null,
  user:  null,
  userMenu: sessionStorage.getItem('user-menu')
    ? JSON.parse(sessionStorage.getItem('user-menu'))
    : null,
  isLoggingOut: sessionStorage.getItem('user-is-Logging-out')
    ? JSON.parse(sessionStorage.getItem('user-is-Logging-out'))
    : null,
}

export const initialState = () => _state

export const state = initialState()
